export default __webpack_public_path__ + "static/media/avax.06f9a3e3.svg";